/* eslint-disable no-case-declarations */
// Version : 0.0.3
// Author : Vignesh

import loginActionTypes from './login.types';
import { docodeHexResponse } from '../_common/common.utils';

const INITIAL_STATE: any = {
	loginResponse: null,
	loginDateTime: null,
	authCheckDone: 0,
	loginDeocodedResponse: [],
	userAuthVerifyResponse: null,
	loginVerificationResponse: null,
	currencySymbols: '',
	forgotPasswordResponse: null,
	forgotPasswordDeocodedResponse: null,
	updateUserPasswordStatus: null,
	updateUserPasswordResponse: [],
	getUserLoginDetailsResponse: null,
	getUserLoginDetailsArr: [],
	fetchUserDetailsResponse: null,
	fetchUserDetailsArr: [],
};

const loginReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/***************  USER LOGIN START  ******************/
		case loginActionTypes.USER_SIGN_IN_SUCCESS:
			const decodedResponse = docodeHexResponse(action.payload, 'UserLoginVerify');
			return {
				...state,
				loginResponse: action.payload,
				loginDeocodedResponse: decodedResponse || [],
			};

		case loginActionTypes.USER_SIGN_IN_FAILURE:
			return {
				...state,
				loginResponse: action.payload,
				loginDeocodedResponse: null,
			};

		case loginActionTypes.USER_SIGN_IN_RESPONSE_CHANGED:
			return {
				...state,
				loginResponse: null,
				loginDeocodedResponse: null,
			};
		/***************  USER LOGIN END  ******************/

		case loginActionTypes.USER_SIGN_IN_VERIFICATION_SUCCESS:
			return {
				...state,
				loginVerificationResponse: action.payload,
			};

		case loginActionTypes.USER_SIGN_IN_VERIFICATION_FAILURE:
			return {
				...state,
				loginVerificationResponse: action.payload,
			};

		case loginActionTypes.USER_SIGN_IN_VERIFICATION_RESPONSE_CHANGED:
			return {
				...state,
				loginVerificationResponse: null,
			};
		/***************  USER SESSION CREATION START  ******************/

		case loginActionTypes.USER_SIGN_IN_SESSION_CREATION_SUCCESS:
			return {
				...state,
				loginVerificationResponse: action.payload,
			};

		case loginActionTypes.USER_SIGN_IN_SESSION_CREATION_FAILURE:
			return {
				...state,
				loginVerificationResponse: action.payload,
			};

		case loginActionTypes.USER_SIGN_IN_SESSION_CREATION_RESPONSE_CHANGED:
			return {
				...state,
				loginVerificationResponse: null,
			};
		/***************  USER SESSION CREATION END  ******************/

		case loginActionTypes.USER_SIGN_OUT:
			return {
				...state,
				authCheckDone: 0,
				loginDateTime: null,
				loginResponse: null,
				loginDeocodedResponse: [],
				getUserLoginDetailsResponse: null,
				getUserLoginDetailsArr: [],
			};

		case loginActionTypes.USER_AUTH_CHECK_DONE_CHANGED:
			return {
				...state,
				authCheckDone: action.payload,
			};

		case loginActionTypes.USER_LOGIN_TIME_CHANGED:
			return {
				...state,
				loginDateTime: action.payload,
			};
		/***************  USER LOGIN END  ******************/

		/*****************  USER AUTH VERIFY START  *******************/
		case loginActionTypes.USER_AUTH_VERIFY_SUCCESS:
			return {
				...state,
				userAuthVerifyResponse: action.payload,
			};

		case loginActionTypes.USER_AUTH_VERIFY_FAILURE:
			return {
				...state,
				userAuthVerifyResponse: action.payload,
			};

		case loginActionTypes.USER_AUTH_VERIFY_RESPONSE_CHANGED:
			return {
				...state,
				userAuthVerifyResponse: null,
			};

		/***************** 	USER AUTH VERIFY END  *****************/

		/*****************  FORGOT PASSWORD START  *******************/
		case loginActionTypes.FETCH_FORGOT_PASSWORD_SUCCESS:
			const forgotPasswordDecoded = docodeHexResponse(action.payload, 'ForgotPassKey');
			return {
				...state,
				forgotPasswordResponse: action.payload,
				forgotPasswordDeocodedResponse: forgotPasswordDecoded || null,
			};

		case loginActionTypes.FETCH_FORGOT_PASSWORD_FAILURE:
			const forgotPasswordDecodedFailure = docodeHexResponse(action.payload, 'ForgotPassKey');
			return {
				...state,
				forgotPasswordResponse: action.payload,
				forgotPasswordDeocodedResponse: forgotPasswordDecodedFailure || null,
			};

		case loginActionTypes.FETCH_FORGOT_PASSWORD_RESPONSE_CHANGED:
			return {
				...state,
				forgotPasswordResponse: null,
				forgotPasswordDeocodedResponse: null,
			};

		/***************** 	FORGOT PASSWORD END  *****************/

		/*****************  UPDATE LOGIN USER PASSWORD START  *******************/
		case loginActionTypes.UPDATE_USER_PASSWORD_SUCCESS:
			const updatePasswordDecoded = docodeHexResponse(
				action.payload,
				'UPDATEUSERPASSWORDKEY',
			);
			return {
				...state,
				updateUserPasswordStatus: action.payload,
				updateUserPasswordResponse: updatePasswordDecoded || [],
			};

		case loginActionTypes.UPDATE_USER_PASSWORD_FAILURE:
			return {
				...state,
				updateUserPasswordStatus: action.payload,
			};

		case loginActionTypes.UPDATE_USER_PASSWORD_RESPONSE_CHANGED:
			return {
				...state,
				updateUserPasswordStatus: null,
			};

		/***************** 	UPDATE LOGIN USER PASSWORD END  *****************/
		/** ***************** GET USER COMPANY DETAILS START *********************** */
		case loginActionTypes.FETCH_USER_COMPANY_DETAILS_SUCCESS:
			const userCompanyDetailsDecoded = docodeHexResponse(
				action.payload,
				'GetUserCompanyDetailsKey',
			);
			return {
				...state,
				getUserLoginDetailsResponse: action.payload,
				getUserLoginDetailsArr: userCompanyDetailsDecoded || [],
			};

		case loginActionTypes.FETCH_USER_COMPANY_DETAILS_FAILURE:
			return {
				...state,
				getUserLoginDetailsResponse: action.payload,
				getUserLoginDetailsArr: [],
			};

		case loginActionTypes.FETCH_USER_COMPANY_DETAILS_RESPONSE_CHANGED:
			return { ...state, getUserLoginDetailsResponse: null };

		/** ***************** GET USER COMPANY DETAILS END *********************** */

		/** ***************** FETCH USER DETAILS START *********************** */
		case loginActionTypes.FETCH_USER_DETAILS_SUCCESS:
			const userDetailsDecoded = docodeHexResponse(action.payload, 'GetUserDetailsKey');
			return {
				...state,
				fetchUserDetailsResponse: action.payload,
				fetchUserDetailsArr: userDetailsDecoded || [],
			};

		case loginActionTypes.FETCH_USER_DETAILS_FAILURE:
			return {
				...state,
				fetchUserDetailsResponse: action.payload,
				fetchUserDetailsArr: [],
			};

		case loginActionTypes.FETCH_USER_DETAILS_RESPONSE_CHANGED:
			return { ...state, fetchUserDetailsResponse: null };
		/** ***************** FETCH USER DETAILS END *********************** */

		/** ***************** UPDATE USER ACCESS BRANCH START *********************** */
		case loginActionTypes.UPDATE_USER_ACCESS_BRANCH:
			const updatedLoginDetails = [...state.getUserLoginDetailsArr];
			if (updatedLoginDetails.length > 0 && updatedLoginDetails[0].UserAccess) {
				updatedLoginDetails[0].UserAccess = updatedLoginDetails[0].UserAccess.map(
					(ua: any) => ({
						...ua,
						IsSelected:
							ua.UserAccessBranchID === action.payload.UserAccessBranchID ||
							ua.UserAccessBranchID === String(action.payload.UserAccessBranchID)
								? 1
								: 0,
					}),
				);
			}
			const updatedUserDetails = [...state.fetchUserDetailsArr];
			if (updatedUserDetails.length > 0 && updatedUserDetails[0].UserAccess) {
				updatedUserDetails[0].UserAccess = updatedUserDetails[0].UserAccess.map(
					(ua: any) => ({
						...ua,
						IsSelected:
							ua.UserAccessBranchID === action.payload.UserAccessBranchID ||
							ua.UserAccessBranchID === String(action.payload.UserAccessBranchID)
								? 1
								: 0,
					}),
				);
			}
			return {
				...state,
				getUserLoginDetailsArr: updatedLoginDetails,
				fetchUserDetailsArr: updatedUserDetails,
			};
		/** ***************** UPDATE USER ACCESS BRANCH END *********************** */

		default:
			return state;
	}
};

export default loginReducer;
